// src/components/FeaturedProjects.jsx

import React, { Suspense } from "react";
import Slider from "react-slick";
import ProjectCard from "./ProjectCard";
import { motion } from "framer-motion";

const FeaturedProjects = ({ featuredRepos, sliderSettings }) => {
  if (featuredRepos.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      className="mb-12"
    >
      <h2 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
        Featured Projects
      </h2>

      {/* Carousel for Mobile View */}
      <div className="block md:hidden">
        <Slider {...sliderSettings}>
          {featuredRepos.map((repo) => (
            <div key={repo.id} className="px-2">
              <Suspense
                fallback={
                  <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 animate-pulse">
                    <div className="h-8 bg-white/10 rounded mb-4"></div>
                    <div className="h-4 bg-white/10 rounded mb-2"></div>
                    <div className="h-4 bg-white/10 rounded w-3/4"></div>
                  </div>
                }
              >
                <ProjectCard repo={repo} />
              </Suspense>
            </div>
          ))}
        </Slider>
      </div>

      {/* Grid for Desktop View */}
      <div className="hidden md:grid grid-cols-1 lg:grid-cols-2 gap-6">
        {featuredRepos.map((repo) => (
          <Suspense
            fallback={
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 animate-pulse">
                <div className="h-8 bg-white/10 rounded mb-4"></div>
                <div className="h-4 bg-white/10 rounded mb-2"></div>
                <div className="h-4 bg-white/10 rounded w-3/4"></div>
              </div>
            }
            key={repo.id}
          >
            <ProjectCard repo={repo} />
          </Suspense>
        ))}
      </div>
    </motion.div>
  );
};

export default FeaturedProjects;
